"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const scenarios = [{
  title: "通勤时刻",
  description: "利用碎片时间，精听短篇英语新闻或播客，让每天的上下班路上成为你的专属英语角。",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618423/img/commute_illustration.png",
  buttonText: "立即试听",
  link: "/OnlineAppPage"
}, {
  title: "考试冲刺",
  description: "专攻雅思、托福历年真题听力，逐句拆解长难句，智能记忆系统助你高效提分。",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618423/img/exam_prep_illustration.png",
  buttonText: "立即试听",
  link: "/OnlineAppPage"
}, {
  title: "职场提升",
  description: "精选商业资讯与专业演讲，提升商务英语听力，在跨国会议与职场交流中自信表达。",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618423/img/career_boost_illustration.png",
  buttonText: "立即试听",
  link: "/OnlineAppPage"
}];
export default function FullScenarioCoverage() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="全场景覆盖为目标而战" className="bg-background py-24 px-6 md:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={ref} className={`text-center mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-5xl font-extrabold text-foreground tracking-tight mb-4">
            全场景覆盖，为目标而战
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            无论你是学生、职场人士还是备考大军，听力通都能为你提供最适合的训练内容。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {scenarios.map((scenario, i) => <Card key={i} data-index={i} className={`border-2 border-border shadow-[0_8px_0_0_var(--color-border)] rounded-[2rem] overflow-hidden transition-all duration-500 ease-out hover:-translate-y-2 hover:shadow-[0_12px_0_0_var(--color-border)] flex flex-col ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <div className="h-56 w-full bg-muted border-b-2 border-border relative overflow-hidden">
                <img src={scenario.image} alt={scenario.title} className="w-full h-full object-cover" />
              </div>
              <CardHeader className="pt-8 pb-4 text-center">
                <CardTitle className="text-2xl font-bold text-foreground">
                  {scenario.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="flex-grow text-center px-6 md:px-8">
                <CardDescription className="text-base leading-relaxed text-muted-foreground">
                  {scenario.description}
                </CardDescription>
              </CardContent>
              <CardFooter className="pb-8 pt-4 px-6 md:px-8">
                <Button asChild size="lg" className="w-full rounded-2xl text-lg font-bold shadow-[0_4px_0_0_rgba(0,0,0,0.1)] hover:translate-y-[2px] hover:shadow-[0_2px_0_0_rgba(0,0,0,0.1)] active:translate-y-[4px] active:shadow-none transition-all">
                  <Link to={scenario.link}>{scenario.buttonText}</Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}